var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Button } from 'syf-component-library/ui/atoms';
import { fontSizes } from '../../../theme';
export var StyledButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  font-size: ", "px;\n  text-transform: none;\n"], ["\n  margin: 0;\n  font-size: ", "px;\n  text-transform: none;\n"])), fontSizes.root);
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map